import * as tslib_1 from "tslib";
import { ApplicationRef } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { concat, interval } from 'rxjs';
import { first } from 'rxjs/operators';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import * as i0 from "@angular/core";
import * as i1 from "@angular/service-worker";
import * as i2 from "../../../../@fuse/services/translation-loader.service";
var UpdateService = /** @class */ (function () {
    function UpdateService(update, app, fuseTranslationLoaderService) {
        var _this = this;
        this.update = update;
        this.app = app;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        if (!this.update.isEnabled) {
            return;
        }
        var firstTimeAppStable$ = this.app.isStable.pipe(first(function (isStable) { return isStable === true; }));
        var everyHalfHours$ = interval(30 * 60 * 1000);
        concat(firstTimeAppStable$, everyHalfHours$).subscribe(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.update.checkForUpdate()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        this.update.available.subscribe(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.update.activateUpdate()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        this.update.activated.subscribe(function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); });
    }
    UpdateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UpdateService_Factory() { return new UpdateService(i0.ɵɵinject(i1.SwUpdate), i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(i2.FuseTranslationLoaderService)); }, token: UpdateService, providedIn: "root" });
    return UpdateService;
}());
export { UpdateService };
